import PropTypes from "prop-types"
import classNames from "classnames"
import "./style.scss"

function NewFeature({
  small,
  animated,
  seen,
  onClick,
  id,
  tag,
  expired,
  setSeenNewFeature,
  key,
  children,
  className,
}) {
  const Tag = tag || "div"
  const handleSetSeenNewFeature = () => {
    if (!expired && !seen) setSeenNewFeature(id)
    if (onClick) onClick()
  }

  return (
    <Tag
      id={id}
      key={key}
      onClick={handleSetSeenNewFeature}
      className={classNames("components_new-feature", className, {
        "small-icon": small,
        animated,
        visible: !seen && !expired,
      })}
    >
      <div className="new-feature-icon" />
      {children}
    </Tag>
  )
}

NewFeature.propTypes = {
  small: PropTypes.bool,
  animated: PropTypes.bool,
  seen: PropTypes.bool,
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired,
  tag: PropTypes.string,
  expired: PropTypes.bool,
  setSeenNewFeature: PropTypes.func.isRequired,
  key: PropTypes.string,
  className: PropTypes.string,
}

export default NewFeature
